import React, { useState } from "react";
import { formatNum } from "@/lib/api";

export const liveYemek = (r) => {
  const avans = (Number(r.yemek_gunluk_tutar) || 0) * ((Number(r.yemek_gun_sayisi) || 0) + (Number(r.yemek_ek_gun) || 0)) + (Number(r.yemek_ekstra) || 0);
  const net = avans - (Number(r.yemek_iade) || 0);
  return { toplam: Math.max(0, net), kesinti: Math.max(0, -net) };
};

export const liveYol = (r) => {
  const daily = Number(r.yol_gunluk_ucret) || 0;
  const ek = r.yol_gunluk_manuel ? daily * (Number(r.yol_ek_gun) || 0) : Number(r.yol_ek) || 0;
  const base = (Number(r.yol_avans) || 0) - (Number(r.yol_ek) || 0);
  const avans = (r.yol_gunluk_manuel ? (base > 0 ? Math.ceil(daily * 30) : 0) : base) + ek;
  const iade = Number(r.yol_iade) || 0;
  const v = Math.round((avans - iade) * 100) / 100;
  return iade || ek ? Math.ceil(v) : v;
};

export const EntryBadges = ({ row, tp = "" }) => (
  <>
    {row.cikis_gunu && (
      <span data-testid={`${tp}payroll-cikis-${row.sicil_no}`} title={`Bu ay ${row.cikis_gunu}. gün işten çıktı · maaş ${row.calisma_gunu_hesap} gün, çalışılmayan günlerin yemek/yol avansı iade`}
        className="text-[9px] font-black uppercase bg-slate-800 text-white px-1.5 py-0.5 rounded">Çıkış · {row.cikis_gunu}. gün</span>
    )}
    {row.giris_gunu && (
      <span data-testid={`${tp}payroll-giris-${row.sicil_no}`} title={`Bu ay ${row.giris_gunu}. gün işe girdi · maaş ${row.calisma_gunu_hesap} gün; bu ayın ${row.yemek_ek_gun} gün yemeği ve ${row.yol_ek_gun} gün yolu sonraki ay avansına eklendi`}
        className="text-[9px] font-black uppercase bg-sky-700 text-white px-1.5 py-0.5 rounded">Giriş · {row.giris_gunu}. gün</span>
    )}
    {row.maas_bekleniyor && (
      <span data-testid={`${tp}payroll-maas-bekleniyor-${row.sicil_no}`} title="Admin maaş girene kadar banka listesine alınmaz"
        className="text-[9px] font-black uppercase bg-orange-100 text-orange-800 border border-orange-300 px-1.5 py-0.5 rounded">Maaş bekleniyor</span>
    )}
  </>
);

export const EkNote = ({ row, kind, tp = "" }) => {
  const n = kind === "yemek" ? Number(row.yemek_ek_gun) || 0 : Number(row.yol_ek_gun) || 0;
  if (!row.giris_gunu || !n) return null;
  return <div className="text-[10px] font-semibold text-sky-700" data-testid={`${tp}${kind}-ek-${row.sicil_no}`}>+{n} gün bu ay</div>;
};

export const IadeCell = ({ row, idx, kind, isAdmin, updateLocal, tp = "" }) => {
  const [edit, setEdit] = useState(false);
  const val = Number(row[`${kind}_iade`]) || 0;
  const elle = !!row[`${kind}_iade_elle`];
  const oto = Number(row[`${kind}_iade_oto`]) || 0;
  if (!val && !elle && !oto) return null;
  const sic = row.sicil_no;
  if (edit && isAdmin) {
    return (
      <div className="flex items-center gap-0.5 mt-0.5">
        <input autoFocus type="number" step="0.01" min="0" defaultValue={val} data-testid={`${tp}${kind}-iade-input-${sic}`}
          className="!w-20 !text-[11px]"
          onBlur={(e) => { updateLocal(idx, `${kind}_iade`, Number(e.target.value) || 0); updateLocal(idx, `${kind}_iade_elle`, true); setEdit(false); }} />
      </div>
    );
  }
  return (
    <div className="text-[10px] leading-tight mt-0.5" data-testid={`${tp}${kind}-iade-${sic}`}>
      <button type="button" disabled={!isAdmin} onClick={() => setEdit(true)}
        title={isAdmin ? "Eksi bakiyeyi düzenle (0 = sıfırla)" : "Önceden verilen avansın çalışılmayan günler için iadesi"}
        className={`font-bold ${elle ? "text-amber-700" : "text-rose-600"} ${isAdmin ? "hover:underline" : "cursor-default"}`}>
        iade −{formatNum(val)}{elle ? " (elle)" : ""}
      </button>
      {elle && isAdmin && (
        <button type="button" data-testid={`${tp}${kind}-iade-reset-${sic}`} title={`Otomatiğe dön (${formatNum(oto)})`}
          onClick={() => { updateLocal(idx, `${kind}_iade`, oto); updateLocal(idx, `${kind}_iade_elle`, false); }}
          className="block text-[9px] text-slate-500 hover:underline">oto'ya dön</button>
      )}
    </div>
  );
};
